module.exports = __webpack_public_path__ + "static/img/gongsishouye_11.a3f5c269.jpg";